function get12HourTime(hhmm) {
    var H = +hhmm.substring(0, 2)
    var h = (H % 12) || 12
    var ampm = H < 12 ? "AM" : "PM"
    return h + ":" + hhmm.substring(2, 4) + " " + ampm
}

export default get12HourTime
